import { useState, useEffect } from 'react'

const MediaPreview = ({ file }) => {
  const [previewUrl, setPreviewUrl] = useState(null)
  const [error, setError] = useState(null)
  const [fileType, setFileType] = useState(null)
  
  useEffect(() => {
    if (!file) {
      setPreviewUrl(null)
      return
    }
    
    // Check if this is a valid File object (not just metadata)
    if (!(file instanceof File)) {
      setError(null) // Don't show error for non-File objects, just don't show preview
      setPreviewUrl(null)
      return
    }
    
    // Determine file type
    if (file.type.startsWith('image/')) {
      setFileType('image')
    } else if (file.type.startsWith('video/')) {
      setFileType('video')
    } else {
      setError('File is not an image or video')
      setPreviewUrl(null)
      return
    }
    
    const reader = new FileReader()
    reader.onload = () => {
      setPreviewUrl(reader.result)
      setError(null)
    }
    reader.onerror = () => {
      setError('Failed to read file')
      setPreviewUrl(null)
    }
    reader.readAsDataURL(file)
    
    // Clean up when component unmounts
    return () => {
      if (previewUrl && previewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(previewUrl)
      }
    }
  }, [file])
  
  if (error) {
    return <div className="text-red-500 text-sm">{error}</div>
  }
  
  if (!previewUrl) {
    return null
  }
  
  return (
    <div>
      <div className="relative">
        {fileType === 'image' && (
          <img 
            src={previewUrl} 
            alt="Preview" 
            className="object-cover rounded-md border border-gray-300"
            style={{ 
              width: '100px', 
              height: '100px',
              objectFit: 'cover'
            }}
          />
        )}
        {fileType === 'video' && (
          <video 
            src={previewUrl} 
            controls
            className="object-cover rounded-md border border-gray-300"
            style={{ 
              width: '100px', 
              height: '100px',
              objectFit: 'cover'
            }}
          >
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </div>
  )
}

export default MediaPreview
